import React, { useContext } from "react";
import { Link, useParams, useNavigate } from 'react-router-dom';
import logoSmall from './../../../public/Images/logo.png';
import './index.css';
import { AuthContext } from '../Context/auth.jsx';
import DashboardRH from "../../app/RhChamado/dashboard.jsx";


function Menu(props) {
    const navigate = useNavigate();
    const { setLogado } = useContext(AuthContext);
    const { id } = useParams();
    const chapa = localStorage.getItem("chapa");
    const AcessoSap = localStorage.getItem("SAPADM");
    // 🔹 Adicionado: Permissão de vendas lida do localStorage
    const permiteVendas = localStorage.getItem("permiteVendas");
    const permitePonto = localStorage.getItem("permitePonto");
    const permiteCheckList = localStorage.getItem("CHECKLIST");
    const permiteCadastroCheckTI = localStorage.getItem("TICADCHECKLIST");
    const permiteRegional = localStorage.getItem("permiteRegional");
    const permiteDashBoardRH = localStorage.getItem("RHDASHBOARD");
    console.log("flosoftnew " + permiteDashBoardRH);
    const isRestrito = chapa?.startsWith("90");

    function Logout() {
        setLogado(false);
        localStorage.clear();
    }

    const isSapOrArbor = props.modulo === "SAP" || props.modulo === "ARBOR" || chapa === '900010' || chapa === '900001';
    const hasAccessToTools = AcessoSap === "S" || chapa === '900010' || chapa === '900001';
    // 🔹 Adicionado: Variável para verificar acesso às vendas
    const hasAccessToVendas = AcessoSap === "S" || permiteVendas === "S";
    const isCheckCadastro = permiteCadastroCheckTI === "S";
    const itsChecklist = permiteCheckList === "S";
    const itsAcessoRegional = chapa === '900010' || chapa === '900001';

    return (
        <nav className="navbar fixed-top navbar-expand-md navbar-dark">
            <div className="container-fluid">
                <a aria-current="page" href="#">
                    <img className="logoarbor" src={logoSmall} alt="Rede Supermarket" title="Rede Supermarket" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto">
                        {/* Menu REST */}
                        {!isRestrito && props.modulo === "REST" && (
                            <>
                                <li className="nav-item">
                                    <Link to={"/restaurante/avaliacao/"} className="nav-link"><i className="fa fa-star" /> Avaliações</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to={"/restaurante/cardapio/"} className="nav-link"><i className="fa fa-pencil" /> Cardápio</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to={"/restaurante/dados/"} className="nav-link"><i className="fa fa-address-card-o" /> Dados Cadastrais</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="#" className="nav-link"><i className="fa fa-whatsapp" /> Extrato de Refeições</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to={"/restaurante/pedido/"} className="nav-link"><i className="fa fa-cutlery" /> Pedidos</Link>
                                </li>
                            </>
                        )}

                        {(!isRestrito && isSapOrArbor || itsAcessoRegional) && (
                            <li className="nav-item">
                                <Link to={"/arbor/home"} className="nav-link"><i className="fa fa-home" /> Principal</Link>
                            </li>
                        )}
                        {/* Menu Recursos Humanos */}
                        {!isRestrito && isSapOrArbor && (

                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Recursos Humanos
                                </a>
                                <ul className="dropdown-menu">
                                    <li><Link to={"/arbor/aeflor"} className="dropdown-item"><i className="fa fa-user-plus" /> AEFLOR - Eventos</Link></li>
                                    {(DashboardRH === "S" || (!isRestrito && isSapOrArbor)) && (
                                        <>
                                            <li><Link to={"/arbor/chamado"} className="dropdown-item"><i className="fa fa-question-circle" /> Atendimento RH</Link></li>
                                            <li><Link to={"/arbor/atestado"} className="dropdown-item"><i className="fa fa-user-md" /> Atestados</Link></li>
                                            <li><Link to={"/arbor/aeflor/convenio"} className="dropdown-item"><i className="fa fa-credit-card" /> Convênio</Link></li>
                                            <li><Link to={"/arbor/dadosfunc/"} className="dropdown-item"><i className="fa fa-address-card" /> Meus Dados</Link></li>
                                            <li><Link to={"/arbor/escala/"} className="dropdown-item"><i className="fa fa-calendar" /> Escala de trabalho</Link></li>
                                            <li><Link to={"/arbor/holerite/"} className="dropdown-item"><i className="fa fa-envelope-o" /> Holerites</Link></li>
                                            <li><Link to={"/arbor/notificacoes/"} className="dropdown-item"><i className="fa fa-bell" /> Notificações</Link></li>
                                            <li><Link to={"/arbor/ponto/"} className="dropdown-item"><i className="fa fa-clock-o" /> Ponto</Link></li>
                                        </>
                                    )}

                                    <li><Link to={"/arbor/restaurante/"} className="dropdown-item"><i className="fa fa-check-square-o" /> Refeição</Link></li>

                                </ul>
                            </li>
                        )}

                        {/* Menu Ferramentas */}
                        {isSapOrArbor && (
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Ferramentas
                                </a>
                                <ul className="dropdown-menu">

                                    <>
                                        <li><Link to={"/arbor/produto/"} className="dropdown-item"><i className="fa fa-barcode" /> Etiqueta</Link></li>
                                    </>


                                    {permiteVendas === 'S' && (
                                        <>
                                            <li><Link to={"/arbor/rh/acidente/"} className="dropdown-item"><i className="fa fa-user-md" /> Comunicado de Ocorrência</Link></li>
                                            <li><Link to={"/arbor/usuario/consinco/"} className="dropdown-item"><i className="fa fa-users" /> Associar Operador PDV</Link></li>
                                        </ >
                                    )}
                                    {/*CHECKLIST*/}
                                    {isCheckCadastro && (
                                        <>
                                            <li><Link to={"/arbor/checklist/cadastro/"} className="dropdown-item"><i className="fa fa-list" /> Cadastro Itens CheckList</Link></li>
                                        </>
                                    )}
                                    {itsChecklist && (
                                        <>
                                            <li><Link to={"/arbor/checklist/checklist/"} className="dropdown-item"><i className="fa fa-check-square-o" /> CheckList TI</Link></li>
                                        </>
                                    )}
                                    {/*FIM CHECKLIST*/}

                                    {permiteDashBoardRH === "S" && (
                                        <li>
                                            <Link to="/arbor/rh/dashboard" className="dropdown-item">
                                                <i className="fa fa-deaf" /> DashBoard RH
                                            </Link>
                                        </li>
                                    )}

                                    {permitePonto === 'S' && (
                                        <>
                                            <li><Link to={"/arbor/ponto/ocorrencias/"} className="dropdown-item"><i className="fa fa-clock-o" /> Ocorrências de ponto</Link></li>
                                        </>
                                    )}

                                    {/*COMUNICADO*/}
                                    {permiteRegional === 'S' && (
                                        <>
                                            <li><Link to={"/arbor/comunicado/"} className="dropdown-item"><i className="fa fa-address-book" /> Comunicação RH</Link></li>
                                        </>
                                    )}




                                    {/* 🔹 Alterado: Condição de exibição dos links de Vendas */}
                                    {permiteVendas === 'S' && (
                                        <>
                                            <li><Link to={"/arbor/produto/auditoria/"} className="dropdown-item"><i className="fa fa-cubes" /> Auditoria de produto</Link></li>
                                            <li><Link to={"/arbor/vendas/flash/"} className="dropdown-item"><i className="fa fa-bolt" /> Vendas - Flash</Link></li>
                                            <li><Link to={"/arbor/vendas/mes/"} className="dropdown-item"><i className="fa fa-line-chart" /> Vendas - Período</Link></li>
                                            <li><Link to={"/arbor/vendas/loja/"} className="dropdown-item"><i className="fa fa-line-chart" /> Vendas - Período Loja</Link></li>
                                            <li><Link to={"/arbor/vendas/comparativo/"} className="dropdown-item"><i className="fa fa-line-chart" /> Vendas - Comparativo</Link></li>

                                        </>
                                    )}

                                    {/* Item SAP */}
                                    {AcessoSap === "S" && (
                                        <li><Link to={"/arbor/sap/"} className="dropdown-item txt-maiusculo"><i className="fa fa-money" /> Sap</Link></li>
                                    )}

                                    <>
                                        <li><Link to={"/arbor/validade/"} className="dropdown-item"><i className="fa fa-calendar" /> Validade </Link></li>
                                    </>
                                </ul>
                            </li>
                        )}

                        {/* Item Ouvidoria - FORA DO MENU DE FERRAMENTAS */}
                        {(isSapOrArbor && !isRestrito || chapa === '900010') && (
                            <li className="nav-item">
                                <Link to={"/arbor/ouvidoria/"} className="nav-link"><i className="fa fa-deaf" /> Ouvidoria</Link>
                            </li>
                        )}

                        {/* Item Horários */}
                        {!isRestrito && props.modulo === "SAP" && (
                            <li className="nav-item">
                                <Link to={"/arbor/sap/horario/"} className="nav-link"><i className="fa fa-clock-o" /> Horários</Link>
                            </li>
                        )}

                        {/* Botão de Sair */}
                        {props.modulo !== "NOVO1" && (
                            <li className="nav-item">
                                <a href="/" onClick={Logout} className="nav-link"><i className="fa fa-sign-out" /> Sair</a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Menu;